import { NgModule } from '@angular/core';

import { FilterPipe } from '@core/pipes/filter.pipe';

import { InitialsPipe } from '@core/pipes/initials.pipe';

import { NormalizePipe } from './normalize.pipe';
import { CustomCurrencyPipe } from './currency.pipe';
import { TranslateFieldPipe } from './translate-field.pipe';
import { MSTranslateValue } from './ms-translate-value.pipe';
import { ConcatArrayPipe } from './concat-array.pipe';
import { PorcentagePipe } from './percentage.pipe';
import { ReplacePipe } from './replace.pipe';
import { ReplaceCitations } from './replace-citations.pipe';
import { ChatAnswer } from './chat-answer.pipe';
import { ChatQuestions } from './chat-questions.pipe';
import { JoinPropertyPipe } from './join-property.pipe';
import { FilterListPipe } from './filter-list.pipe';

@NgModule({
  declarations: [InitialsPipe, FilterPipe, NormalizePipe, CustomCurrencyPipe, TranslateFieldPipe, MSTranslateValue, ConcatArrayPipe, PorcentagePipe, ReplacePipe, ReplaceCitations, ChatAnswer, ChatQuestions, JoinPropertyPipe, FilterListPipe],
  imports: [],
  exports: [InitialsPipe, FilterPipe, NormalizePipe, CustomCurrencyPipe, TranslateFieldPipe, MSTranslateValue, ConcatArrayPipe, PorcentagePipe, ReplacePipe, ReplaceCitations, ChatAnswer, ChatQuestions, JoinPropertyPipe, FilterListPipe]
})
export class CorePipesModule {}
